{
	"title": "Sets and periods",
	"actions": {
		"discardSide": "Discard this side's changes"
	},
	"board": {
		"needsTwo": "This screen needs exactly two competitors. This meet has {{n}}. Fix the start list first.",
		"setsWon": "Sets won",
		"gamesWon": "Games won",
		"goals": "Score",
		"setColumn": "Set",
		"gameColumn": "Game",
		"periodColumn": "Period",
		"stateColumn": "State",
		"addExtra": "Add extra time",
		"addShootout": "Add shoot-out",
		"removeRow": "Remove {{row}}",
		"waitingForSource": "This match waits for its competitors. Scores can be entered once both are known.",
		"mismatch": "The saved result does not match the scores.",
		"mismatchDetail": "From the scores: {{a}} {{score}} {{b}}, {{outcome}} for {{a}}.",
		"undecided": "not decided",
		"useComputed": "Use the result from the scores",
		"familyChanged": "This meet's result type was changed elsewhere. Reload the page; your edits are kept on this device.",
		"unsaved_one": "{{count}} side not saved",
		"unsaved_other": "{{count}} sides not saved",
		"versus": "v",
		"irmHint": "Type WO, RET or DSQ in a score box to mark that side.",
		"framesWon": "Frames won",
		"racksWon": "Racks won",
		"runs": "Runs",
		"addOvertime": "Add overtime",
		"addNamed": "Add {{label}}",
		"addEnd": "Add end",
		"addShootoutWord": {
			"PENS": "Add penalties",
			"SO": "Add shootout",
			"SUPER_OVER": "Add super over"
		},
		"target": "Played to {{n}}. Not checked: type the score as it stands."
	},
	"cell": {
		"label": "{{row}}, {{name}}",
		"wholeNumber": "Whole numbers only",
		"tooHigh": "At most {{max}}",
		"enterToMark": "Enter marks {{irm}}"
	},
	"row": {
		"set": "Set {{n}}",
		"game": "Game {{n}}",
		"half": "Half {{n}}",
		"quarter": "Quarter {{n}}",
		"period": "Period {{n}}",
		"extra": "Extra time {{n}}",
		"shootout": "Shoot-out",
		"end": "End {{n}}",
		"frame": "Frame {{n}}",
		"rack": "Rack {{n}}",
		"round": "Round {{n}}",
		"innings": "Innings {{n}}",
		"leg": "Leg {{n}}",
		"race": "Race {{n}}",
		"overtime": "Overtime {{n}}",
		"extraNamed": "{{label}}",
		"racks": "Racks",
		"shootoutWord": {
			"PENS": "Penalties",
			"SO": "Shootout",
			"SUPER_OVER": "Super over"
		}
	},
	"setState": {
		"COMPLETE": "Won by {{code}}",
		"IN_PROGRESS": "In play",
		"INVALID": "Not a possible score",
		"notNeeded": "Not needed"
	},
	"side": {
		"HOME": "Home",
		"AWAY": "Away",
		"RED": "Red",
		"BLUE": "Blue",
		"WHITE": "White",
		"AKA": "Aka",
		"AO": "Ao",
		"seq": "Seq {{n}}"
	},
	"irm": {
		"label": "Result mark for {{name}}",
		"none": "No mark"
	},
	"state": {
		"restored": "Not saved yet, kept on this device",
		"waitingToSend": "Waiting to send",
		"theirs": "Saved by someone else: {{value}}",
		"theirsEmpty": "no score",
		"loadingTheirs": "Loading their version…"
	},
	"refused": {
		"official": "The meet is official. To change results, change the Meet status (you will be asked to confirm).",
		"locked": "The event is locked by the medal desk.",
		"field": "Not accepted: {{field}}",
		"wholeRow": "the row",
		"not_found": "This slot is no longer in the meet. Reload the page.",
		"forbidden": "Your role cannot change these results.",
		"conflict": "The server refused this change. Reload the page.",
		"unknown": "The server refused this change."
	},
	"format": {
		"bestOf": "Best of {{n}}",
		"periods_one": "{{count}} period",
		"periods_other": "{{count}} periods",
		"periodsOfMinutes_one": "{{count}} period of {{minutes}} min",
		"periodsOfMinutes_other": "{{count}} periods of {{minutes}} min",
		"unset": "No match format yet",
		"unsetReadOnly": "This meet has no match format yet, so there are no scores to show.",
		"change": "Change format",
		"kind": "Decided by",
		"kindBestOf": "Sets won",
		"kindPeriods": "Total score",
		"bestOfLabel": "Best of",
		"periodsLabel": "Periods",
		"minutesLabel": "Minutes each",
		"periodsInvalid": "Periods: a whole number from 1 to {{max}}",
		"minutesInvalid": "Minutes: a whole number from 1 to 200",
		"save": "Save format",
		"stale": "Someone changed this meet first. It has been reloaded; choose again.",
		"raceTo": "Race to {{n}}",
		"playAll": "{{n}} games, all played",
		"overs_one": "{{count}} over an innings",
		"overs_other": "{{count}} overs an innings",
		"kindRaceTo": "Race to",
		"kindInnings": "Innings",
		"raceToLabel": "First to",
		"oversLabel": "Overs an innings",
		"raceToInvalid": "Race to: a whole number from 1 to {{max}}",
		"oversInvalid": "Overs: a whole number from 1 to {{max}}"
	},
	"rule": {
		"BADMINTON": "21 points, win by 2, at most 30",
		"TABLE_TENNIS": "11 points, win by 2",
		"VOLLEYBALL": "25 points, win by 2; deciding set 15",
		"SEPAK_TAKRAW": "15 points, win by 2, at most 17",
		"BEACH_VOLLEYBALL": "21 points, win by 2; deciding set 15",
		"TENNIS": "6 games, win by 2; tie-break at 6–6",
		"TENNIS_MATCH_TIEBREAK": "6 games, win by 2; tie-break at 6–6; deciding set a 10-point match tie-break",
		"PADEL": "6 games, win by 2; tie-break at 6–6",
		"SQUASH": "11 points, win by 2",
		"TEQBALL": "12 points, win by 2",
		"none": "No set rule for this sport: any lead wins the set"
	},
	"source": {
		"winnerOf": "Winner of {{meetNo}}",
		"loserOf": "Loser of {{meetNo}}",
		"placeInMeet": "Place {{rank}} in {{meetNo}}",
		"placeInPool": "Group {{pool}}, place {{rank}}",
		"placeInPhase": "Place {{rank}}",
		"unknown": "To be decided"
	},
	"tie": {
		"rubbersWon": "Matches won",
		"progress": "{{decided}} of {{total}} matches decided",
		"differs": "The tie shows {{stored}}; the matches give {{computed}}.",
		"notWritten": "The matches give {{computed}}; the tie has no score yet.",
		"write": "Update tie score",
		"rubber": "Match",
		"versus": "v",
		"noPlayers": "players not set",
		"wonBy": "Won by {{code}}",
		"openAlone": "Open on its own",
		"players": "Players",
		"hint": "Open a match to enter its scores. The tie score follows each match as it is saved.",
		"noRubbers": "This tie has no individual matches yet. Ties added with Add meet come with their matches; until then only the format can be chosen here.",
		"notNeeded": "Not needed",
		"teamNoMark": "Team plays"
	},
	"lineup": {
		"edit": "Edit line-up",
		"editTitle": "Who plays for {{name}}",
		"positionFor": "Position of {{name}}",
		"pickedCount_one": "{{count}} player picked, in playing order",
		"pickedCount_other": "{{count}} players picked, in playing order",
		"squadCount_one": "{{count}} in the squad, {{starters}} starting",
		"squadCount_other": "{{count}} in the squad, {{starters}} starting",
		"starter": "Starting",
		"bench": "Substitutes",
		"captain": "Captain",
		"alsoPlays": "also plays {{meets}}",
		"save": "Save line-up",
		"saved": "Line-up saved",
		"empty": "No line-up yet.",
		"rosterFailed": "The team list could not be loaded. Only players already in the line-up are shown.",
		"strangers": "Someone picked is not on this team's roster.",
		"invalid": "The line-up was not accepted. Check the players and try again.",
		"offline": "No connection. The line-up was not saved.",
		"stale": "Someone saved this side first.",
		"holdsEvents": "Has goals or cards in this match, so stays in the line-up. Remove the event first.",
		"ofMax": "{{count}} of {{max}} picked, in playing order",
		"tooMany": "This rubber takes {{max}} a side. Remove a player before saving.",
		"sameKind": "already plays {{kind}} in {{meet}}",
		"kind": {
			"SINGLES": "a singles",
			"DOUBLES": "a doubles"
		},
		"tieRule": "Not allowed in a tie: a singles takes one player a side, a doubles two, and nobody plays two singles or two doubles."
	},
	"role": {
		"ATHLETE": "Athlete",
		"RESERVE": "Reserve",
		"GUIDE": "Guide",
		"PILOT": "Pilot",
		"COX": "Cox"
	},
	"events": {
		"title": "Match events",
		"agrees": "Goals listed agree with the score: {{goalsA}}–{{goalsB}}",
		"mismatch": "Goals listed {{goalsA}}–{{goalsB}} do not match the score {{scoreA}}–{{scoreB}}",
		"none": "Nothing recorded yet.",
		"minute": "{{minute}}'",
		"sideLabel": "Team",
		"typeLabel": "What happened",
		"minuteLabel": "Minute",
		"periodLabel": "Period",
		"periodAuto": "Period {{n}} (auto)",
		"periodNone": "No period",
		"periodN": "Period {{n}}",
		"add": "Add",
		"badMinute": "Minute: a whole number from 0 to 200.",
		"willAdd": "{{name}} is not in the line-up and will be added as a substitute.",
		"remove": "Remove {{type}} by {{name}}",
		"lineupOf": "{{name}} line-up",
		"type": {
			"GOAL": "Goal",
			"PENALTY_GOAL": "Penalty goal",
			"OWN_GOAL": "Own goal",
			"YELLOW_CARD": "Yellow card",
			"RED_CARD": "Red card",
			"SUB_IN": "On",
			"SUB_OUT": "Off",
			"SUB": "Substitution"
		},
		"player": "Player",
		"pickPlayer": "Choose a player",
		"group": {
			"pitch": "On the pitch",
			"bench": "Bench",
			"off": "Off the pitch",
			"roster": "Not in the line-up (added as a substitute)"
		},
		"playerOut": "Player off",
		"playerIn": "Player on",
		"needPlayer": "Choose the player.",
		"needSub": "Choose the player going off and the player coming on.",
		"noBench": "Nobody left on the bench",
		"addedLabel": "Stoppage",
		"badAdded": "Stoppage time: a whole number from 1 to 30.",
		"minuteAdded": "{{minute}}+{{added}}'",
		"removeSub": "Remove substitution: {{on}} on for {{off}}",
		"scoreFollows": "The score follows the goals you log.",
		"addedLine": "{{type}} added: {{name}}",
		"subAdded": "Substitution added: {{on}} on for {{off}}",
		"undo": "Undo",
		"undoGone": "That event has changed since; remove it from the timeline instead.",
		"minimize": "Minimize",
		"expand": "Show match events",
		"count_one": "{{count}} event",
		"count_other": "{{count}} events",
		"goalNeedsTime": "A goal needs its minute (or pick the period), so the score can follow it.",
		"addFor": "Add an event for {{team}}",
		"button": {
			"GOAL": "Goal",
			"YELLOW_CARD": "Yellow",
			"RED_CARD": "Red",
			"SUB": "Sub"
		},
		"formTitle": "{{type}} for {{team}}",
		"goalKind": "Kind of goal",
		"cancel": "Cancel",
		"minutePlaceholder": "23 or 45+2",
		"minuteHint": "Type the minute, or 45+2 for stoppage time. The half is worked out from it.",
		"periodGuess": "{{name}}, from the minute"
	},
	"leave": {
		"title": "Leave with unsaved scores?",
		"body": "Some scores on this page are not saved yet. They stay on this device, but nobody else will see them until they are saved.",
		"confirm": "Leave anyway"
	},
	"settings": {
		"button": "Settings"
	},
	"stats": {
		"title": "Match statistics",
		"scopeLabel": "Statistics for",
		"scope": {
			"half": "1st half",
			"full": "Full time",
			"set": "Set {{n}}",
			"match": "Match"
		},
		"hint": "Typed from the match report. Goals and cards come from the match events.",
		"hintScores": "Typed from the scoresheet. Points won are added up from the scores.",
		"hintReport": "Typed from the scoresheet.",
		"col": {
			"stat": "Statistic"
		},
		"fromEvents": "From match events",
		"fromGames": "From the game scores",
		"fromSets": "From the set scores",
		"pointsWon": "Points won",
		"goals": "Goals",
		"yellow": "Yellow cards",
		"red": "Red cards",
		"code": {
			"possession": "Possession %",
			"shots": "Total shots",
			"shots_on_target": "Shots on target",
			"corners": "Corner kicks",
			"fouls": "Fouls committed",
			"offsides": "Offsides",
			"saves": "Goalkeeper saves",
			"most_consecutive_points": "Most consecutive points",
			"service_aces": "Service aces",
			"service_faults": "Service faults",
			"spike_points": "Spike points",
			"block_points": "Block points"
		},
		"input": "{{stat}} for {{team}}",
		"decrease": "Decrease {{stat}} for {{team}}",
		"increase": "Increase {{stat}} for {{team}}",
		"issue": {
			"number": "A whole number from 0 to {{max}}.",
			"onTargetOverShots": "More shots on target than shots.",
			"possessionSum": "Possession should add up to 100%."
		},
		"save": "Save statistics",
		"undo": "Undo changes",
		"unsaved": "Unsaved changes",
		"saved": "Statistics saved",
		"failed": "Not saved. See the save state on the score board above and try again.",
		"minimize": "Minimize",
		"expand": "Show statistics",
		"durations": {
			"title": "Durations",
			"hint": "Minutes, from the scoresheet. The match includes the intervals.",
			"game": "Game {{n}}",
			"match": "Match",
			"minutes": "{{n}} min",
			"save": "Save durations",
			"saved": "Durations saved",
			"stale": "Someone changed this meet first. It has been reloaded; type the durations again.",
			"invalid": "Durations are whole minutes from 0 to {{max}}."
		}
	},
	"tiebreak": {
		"label": "TB",
		"input": "Tie-break points of the loser, {{row}}",
		"hint": "Under a 7–6 set, type the loser's tie-break points; the winner's are worked out.",
		"invalid": "Tie-break points: a whole number from 0 to {{max}}"
	},
	"innings": {
		"battedFirst": "Batted first",
		"pickFirst": "Who batted first? It decides whether the win is by runs or by wickets.",
		"runs": "Runs",
		"wickets": "Wkts",
		"overs": "Overs",
		"oversHint": "Overs as overs.balls, for example 19.4.",
		"runsLabel": "Runs, {{name}}, {{innings}}",
		"wicketsLabel": "Wickets, {{name}}, {{innings}}",
		"oversLabel": "Overs, {{name}}, {{innings}}",
		"main": "Innings",
		"superOver": "Super over",
		"addSuperOver": "Add super over",
		"removeSuperOver": "Remove super over",
		"noResult": "Abandoned, no result",
		"noResultHint": "Both teams take the no-result points.",
		"noResultOn": "No result: the match was abandoned.",
		"tie": "Match tied",
		"wonBy": "{{team}} {{text}}",
		"runsInvalid": "Runs: a whole number from 0 to {{max}}",
		"wicketsInvalid": "Wickets: a whole number from 0 to {{max}}",
		"oversInvalid": "Overs: overs.balls (0 to 5 balls), at most {{max}} overs",
		"save": "Save scores",
		"superOverN": "Super over {{n}}",
		"tieBreak": "Still level after the super overs, won by",
		"tieBreakNone": "Nobody yet",
		"tieBreakHint": "The competition’s tie-break (boundary count, or as its rules say). Used only when every super over is level.",
		"target": "Target",
		"targetLabel": "Revised target, {{name}}",
		"targetHint": "A revised target for a reduced chase (rain): the runs needed to win.",
		"targetInvalid": "Target: a whole number from 1 to {{max}}",
		"reduced": "Overs",
		"reducedLabel": "Reduced overs, {{name}}",
		"reducedHint": "The chase’s own overs when it was reduced.",
		"reducedInvalid": "Overs: a whole number from 1 to {{max}}",
		"closed": "Innings over",
		"closedHint": "Tick when the innings ended early (declared, stopped). All out, the overs used or the target reached end it by themselves.",
		"live": "Not decided yet: the chase, or a super over, is still being played."
	},
	"tsr": {
		"title": "TSR live",
		"none": "TSR has no live score for this match.",
		"readError": "No answer from TSR. Retrying.",
		"unreadable": "TSR sent a score OVR cannot read.",
		"live": "Live",
		"finished": "Finished",
		"score": "{{a}} {{setsA}}–{{setsB}} {{b}}",
		"setsTitle": "Sets, side A first",
		"serving": "{{side}} to serve",
		"apply": "Apply TSR score",
		"applyReadOnly": "This match cannot be edited now.",
		"applied": "TSR score put on the board and saving.",
		"auto": {
			"label": "Auto-apply",
			"hint": "On this computer: save TSR's score and statistics by themselves after every point.",
			"on": "Auto-apply is on: TSR's score and statistics are saved after every point.",
			"waiting": "Auto-apply is waiting: save or discard the edits on the board first.",
			"readOnly": "Auto-apply is on, but this match cannot be edited now.",
			"applied": "TSR score saved automatically.",
			"appliedFinal": "Match ended: TSR's final score saved automatically."
		},
		"refused": {
			"no-slots": "Both sides need a team before the score can be applied.",
			"team-tie": "TSR is scoring a team event game by game. Save it from TSR.",
			"nothing-to-apply": "TSR has no points for this match yet."
		},
		"timeout": "Time-out",
		"timeoutFor": "Time-out: {{side}}, {{seconds}} s",
		"timeoutForNoClock": "Time-out: {{side}}",
		"timeoutsUsed": "Time-outs used: {{a}} {{usedA}}, {{b}} {{usedB}}"
	}
}
